var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCohete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35156 14.9219C6.46094 17.5703 2.92969 17.5703 2.92969 17.5703C2.92969 17.5703 2.92969 14.0391 5.57812 13.1484",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3047 8.73437L10 14.0391L6.46094 10.5L11.7656 5.19531C13.7734 3.1875 15.7813 3.21094 16.6406 3.33594C16.7732 3.35363 16.8963 3.41447 16.9909 3.50907C17.0855 3.60367 17.1464 3.72677 17.1641 3.85937C17.2891 4.71875 17.3125 6.72656 15.3047 8.73437Z",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4219 9.61719V14.6641C14.4195 14.8289 14.3521 14.9862 14.2344 15.1016L11.7109 17.6328C11.6309 17.7128 11.5306 17.7695 11.4208 17.797C11.3111 17.8244 11.1959 17.8215 11.0876 17.7886C10.9794 17.7558 10.882 17.6941 10.8061 17.6102C10.7301 17.5264 10.6783 17.4235 10.6562 17.3125L10 14.0391",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8828 6.07812H5.83594C5.67108 6.08047 5.51383 6.14787 5.39844 6.26563L2.86719 8.78906C2.78723 8.86912 2.73049 8.96939 2.70305 9.07916C2.6756 9.18894 2.67848 9.3041 2.71136 9.41237C2.74424 9.52064 2.8059 9.61796 2.88976 9.69393C2.97361 9.7699 3.07652 9.82168 3.1875 9.84375L6.46094 10.5",
    stroke: "#F8F9FF",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohete);
export default __webpack_public_path__ + "static/media/COHETE.983e469c20eff9627182bf1df4ae1e95.svg";
export { ForwardRef as ReactComponent };